export default __webpack_public_path__ + "static/media/btn_ginasbar.abd254a9.png";